import React from "react";
import { PeekChip, PeekDivider, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
export const StepIndicator = ({ steps, activeStep, sx }) => {
    return (React.createElement(PeekStack, { direction: "row", width: "100%", alignItems: "center", spacing: 2, sx: sx }, steps.map((step, index) => (React.createElement(React.Fragment, { key: index },
        React.createElement(PeekStack, { direction: "row", alignItems: "center", spacing: 0.5 },
            React.createElement(PeekChip, { size: "small", label: index + 1, disabled: activeStep !== index, color: activeStep === index ? "primary" : "info" }),
            React.createElement(PeekTypography, null, step.label)),
        index < steps.length - 1 && React.createElement(PeekDivider, { light: true, sx: { flex: 1, mx: 0.5 } }))))));
};
export default StepIndicator;
